(function () {
  if (window.crapLiveChatInitialized) return;
  window.crapLiveChatInitialized = true;

  var chatReady = false;
  // Match the Help Center and theme: Los Angeles time, including daylight saving time.
  var timeZone = 'America/Los_Angeles';
  var formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: timeZone,
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23'
  });

  function isWithinHours() {
    var values = {};
    formatter.formatToParts(new Date()).forEach(function (part) {
      values[part.type] = part.value;
    });
    var minutes = Number(values.hour) * 60 + Number(values.minute);
    return ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(values.weekday) !== -1
      && minutes >= 11 * 60 && minutes < 17 * 60;
  }

  function updateChat() {
    var available = !!(chatReady && isWithinHours()
      && window.GorgiasChat && typeof window.GorgiasChat.open === 'function');
    var element = document.getElementById('live-chat');
    if (element) {
      element.classList.toggle('active', available);
      element.setAttribute('aria-disabled', available ? 'false' : 'true');
      element.setAttribute('tabindex', available ? '0' : '-1');
    }
    return available;
  }

  function activateChat(event) {
    var target = event.target.closest && event.target.closest('#live-chat');
    if (!target) return;
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    if (event.repeat) return;
    // Recheck on activation in case the tab was suspended at closing time.
    if (updateChat()) window.GorgiasChat.open();
  }

  document.addEventListener('click', activateChat);
  document.addEventListener('keydown', activateChat);
  document.addEventListener('visibilitychange', updateChat);
  document.addEventListener('shopify:section:load', updateChat);
  window.addEventListener('focus', updateChat);
  window.setInterval(updateChat, 1000);
  updateChat();

  // Reuse the installation snippet's initialization promise when available.
  var initialized = window.initGorgiasChatPromise || (window.GorgiasChat
    ? window.GorgiasChat.init()
    : new Promise(function (resolve) {
        window.addEventListener('gorgias-widget-loaded', resolve, { once: true });
      }));

  Promise.resolve(initialized).then(function () {
    // Apply the same hours to this page's widget; dashboard settings are managed separately.
    return window.GorgiasChat.setCustomBusinessHours({
      timezone: timeZone,
      businessHours: [
        { days: [1, 2, 3, 4, 5], fromTime: '11:00', toTime: '17:00' }
      ]
    });
  }).then(function () {
    chatReady = true;
    updateChat();
  }).catch(function (error) {
    chatReady = false;
    updateChat();
    console.warn('Unable to initialize footer live chat.', error);
  });
})();
